import React, { useMemo, useState } from 'react'

import useRecommendation from '../hooks/useRecommendation'
import { useProductPageExpData } from '../templates/productPage/productPage.utils'

import ProductPageContext from './ProductPageContext'

interface ProductPageContextProviderProps {
  children: React.ReactNode
  showFullPDP?: boolean
  updateShowFullPDPInSession?: (val: boolean) => void
}

const ProductPageContextProvider = ({
  children,
  showFullPDP = false,
  updateShowFullPDPInSession = (_: boolean) => {
    //Empty
  },
}: ProductPageContextProviderProps) => {
  const { productPageExpData, similarProductExpData } = useProductPageExpData(showFullPDP)
  const { recommendationUIData, isRecommendationLoading, updateRecommendationAPIData } =
    useRecommendation(productPageExpData)
  const [hasMoreToExplore, setHasMoreToExplore] = useState<boolean>(false)

  const value = useMemo(
    () => ({
      isRecommendationLoading,
      updateRecommendationAPIData,
      hasMoreToExplore,
      setHasMoreToExplore,
      productPageExpData,
      showFullPDP,
      setShowFullPDP: updateShowFullPDPInSession,
      similarProductExpData,
    }),
    [isRecommendationLoading, hasMoreToExplore, productPageExpData, showFullPDP, similarProductExpData],
  )
  return (
    <ProductPageContext.Provider value={{ ...value, recommendationUIData }}>{children}</ProductPageContext.Provider>
  )
}

export default ProductPageContextProvider
